import React, { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import request from 'superagent';
import classNames from 'classnames';

import { useDispatch, useSelector } from 'react-redux';

import { ADMIN_CUSTOMERS_URL } from 'constants/Jaws';
import getAccountType from 'utils/getAccountType';
import * as UserActions from 'actions/user';
import {
  selectCustomerData,
  selectIsAdminUser,
  selectSelectedAccount,
  selectUser,
  selectUserName,
} from '../../state/user/selectors';
import AccountDetails from './AccountDetails';
import moment from 'moment';

if (process.env.NODE_ENV !== 'test') {
  require('./UserSessionPanel.scss');
}

const UserSessionPanel = ({ adminMode }) => {
  const dispatch = useDispatch();
  const [showExpando, setShowExpando] = useState(false);
  const { push, location } = useHistory();

  const user = useSelector(selectUser);
  const customer = useSelector(selectCustomerData);
  const account = useSelector(selectSelectedAccount);
  const isAdmin = useSelector(selectIsAdminUser);
  const userName = useSelector(selectUserName);

  const name =
    adminMode && isAdmin ? userName : account && account.get('fullName');

  const toggleExpando = useCallback(() => {
    setShowExpando(!showExpando);
  }, [showExpando]);

  const handleEndTakeover = useCallback(
    customerId => {
      request
        .post(`${ADMIN_CUSTOMERS_URL}/${customerId}/support-takeover`)
        .query({ enabled: false })
        .end(err => {
          if (err) throw new Error(err);

          dispatch(
            UserActions.fetchUserInfo(() => {
              push('/admin/customers');
            }),
          );
        });
    },
    [dispatch, push],
  );

  const handleLogOut = useCallback(() => {
    if (location.pathname.includes('admin')) {
      dispatch(UserActions.logout(() => push('/admin/login')));
    } else {
      // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
      // !!!! HB depends on this link being to /logged-out because the !!!!
      // !!!!      mobile app is listening for this GET request        !!!!
      // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
      const doNotChange = '/logged-out';
      dispatch(UserActions.logout(() => (window.location = doNotChange)));
    }
  }, [location.pathname, dispatch, push]);

  if (customer || isAdmin) {
    return (
      <>
        <span className="UserSessionPanel hidden-print">
          <button
            data-test-id="userInfo"
            className="user-info"
            aria-expanded={showExpando}
            onClick={toggleExpando}
          >
            <div>
              <p className="account-name">{name}</p>
              <p className="account-type">{getAccountType(account)}</p>
            </div>
            {!adminMode && (
              <span
                className={classNames('arrow-down', {
                  rotate: showExpando,
                })}
              >
                ▾
              </span>
            )}
          </button>
          {!adminMode && showExpando && (
            <AccountDetails
              user={user}
              hideExpand={() => setShowExpando(false)}
              handleLogOut={handleLogOut}
              setActiveAccount={customerId => {
                dispatch(UserActions.setActiveAccount(customerId));
                setTimeout(() => window.location.reload());
              }}
              endTakeover={customerId => {
                handleEndTakeover(customerId);
                window.close();
              }}
            />
          )}
        </span>
        {!adminMode && (
          <span className="UserSessionPanel visible-print">
            <p className="account-name">{account?.get('fullName')}</p>
            <p>{moment().format('LTS L')}</p>
          </span>
        )}
      </>
    );
  }
  return null;
};

export { UserSessionPanel };
export default UserSessionPanel;
